import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PartnershipsSection } from '../components/PartnershipsSection';
export function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <>
      <HeroSection data-id="element-255" />
      <AboutSection data-id="element-256" />
      <PartnershipsSection data-id="element-257" />
    </>;
}